import { authApi } from './authApi';

export const createParty = async (payload: any) => {
  return await authApi.post('admin/party_master/', payload);
};

export const uploadPartyFile = async (payload: any) => {
  return await authApi.post('admin/party_master/upload-file/', payload);
};

export const fetchPartyMaster = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/party_master/${params}`);
};

export const deletePartyMaster = async (payload: { ids: number[] }) => {
  return await authApi.delete(`admin/party_master/`, {
    data: payload,
  });
};

export const exportPartyMaster = async (params = ''): Promise<any> => {
  return await authApi.get(`admin/party_master/export/${params}`);
};

export const updateContractParty = async (payload: any) => {
  return await authApi.patch(`contracts/update-parties/`, payload?.body);
};

export const fetchEditPartyData = async (id: string): Promise<any> => {
  return await authApi.get(`admin/party_master/${id}/`);
};

export const editPartyData = async (payload: any) => {
  return await authApi.patch(
    `admin/party_master/${payload?.id}/`,
    payload?.body
  );
};

export const updatePartyStatus = async (payload: any) => {
  return await authApi.patch(`admin/party_master/status_update/`, payload);
};

// party config
export const fetchPartyConfig = async (): Promise<any> => {
  return await authApi.get('admin/party_config/');
};

export const partyConfigCreate = async (payload: any) => {
  return await authApi.post('admin/party_config/', payload);
};

export const editPartyConfig = async (payload: any) => {
  return await authApi.patch(
    `admin/party_config/${payload?.id}/`,
    payload?.body
  );
};

export const partyBulkUpdate = async (payload: any) => {
  return await authApi.post('admin/party_master/bulk-update/', payload);
};
